import React from 'react';
import { Block, CheckIcon, DefaultText, FlexRow, RightIcon } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  box: ({ isFinished }) => ({
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: isFinished ? '#f5fcf7' : '#f5f5f5',
    },
    cursor: 'pointer',
  }),
  disabled: {
    backgroundColor: 'lightgray',
    color: 'gray',
    cursor: 'default !important',
  },
});

const isFinished = (type, finished) => {
  if (type === 'service' && finished?.service) {
    return true;
  }
  if (type === 'course' && finished?.course) {
    return true;
  }
  if (type === 'event' && finished?.event) {
    return true;
  }
};

const ServiceBlock = ({ title, disabled = false, step = 4, setActiveStep, finished, type }) => {
  const classes = useStyles({ isFinished: isFinished(type, finished) });
  const handleClick = () => {
    if (!disabled) {
      setActiveStep(step, type);
    }
  };

  return (
    <Block
      onClick={handleClick}
      className={disabled ? classes.disabled : classes.box}
      xs={12}
      margin={2}
      marginLeft={0.5}
      padding={4}
      border={borderDefinition(isFinished(type, finished) && '#0bb842')}
      borderRadius={smallBorderRadius}
    >
      <FlexRow margin={0} padding={0}>
        <Block xs={10}>
          <DefaultText fontWeight={800} color={disabled ? 'gray' : isFinished(type, finished) ? 'green' : undefined}>
            {title}
          </DefaultText>
        </Block>
        <Block xs={2} display="flex" flexDirection="row" alignItems="center" justifyContent="end">
          {isFinished(type, finished) ? <CheckIcon fontSize="medium" htmlColor="green" /> : <RightIcon fontSize="medium" />}
        </Block>
      </FlexRow>
    </Block>
  );
};

export default ServiceBlock;
